import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

export interface CasinoPresignedUrlPayload {
  image_type: string;
  identifier: string;
  content_type: string;
  provider?: string;
  sub?: string;
  existing_url?: string | null;
}

type StoredToken = {
  AccessToken?: string;
};

const createCasinoPresignedUrl = async (
  payload: CasinoPresignedUrlPayload
) => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;

  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.ADMIN_UPLOADS_PRESIGNED,
    payload
  );
  return response?.data ?? null;
};

export const useCasinoPresignedUrl = (): UseMutationResult<
  unknown,
  Error,
  CasinoPresignedUrlPayload
> =>
  useMutation({
    mutationKey: ["casinoFm", "presigned-url"],
    mutationFn: createCasinoPresignedUrl,
  });

export { createCasinoPresignedUrl };
